import { FC, useMemo } from 'react';

import { ServiceOfferItem } from '../../../model';
import { DescriptionModal } from '../../PlanCard';
import { transformServiceOffersToPlanCardDescriptions } from './PlanCardUtils';

type Props = {
    items: ServiceOfferItem[];
};

export const PlansDescriptionModal: FC<Props> = ({ items }) => {
    const descriptions = useMemo(() => transformServiceOffersToPlanCardDescriptions(items), [items]);

    return <DescriptionModal descriptions={descriptions} />;
};
